import { Outlet } from 'react-router-dom';

const MyEJOAndESRPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
}

export default MyEJOAndESRPage;